import { create, createLink, query } from './service';

const MaterialModel = {
  namespace: 'material',
  state: {
    // creating
    creating: false,
    folderId: null,
    createdLinks: [],
    createdMaterials: [],
    file2Upload: null,
    fileUploadProgress: 0,

    // data
    materialsData: [],

    // feature
    uploadedFiles: [],
    waitingFiles: [],
  },
  effects: {
    *createMaterial({ payload, signal }, { call, put }) {
      try {
        const response = yield call(create, payload);
        if (response?.id && !response.error && !signal?.aborted) {
          yield put({
            type: 'appendCreated',
            payload: { field: 'createdMaterials', item: response },
          });
        }
        return response;
      } catch (error) {
        return { error: true, message: error.message || '创建资料失败' };
      }
    },

    *createLink({ payload, signal }, { call, put }) {
      try {
        const response = yield call(createLink, payload);
        if (response?.id && !response.error && !signal?.aborted) {
          yield put({ type: 'appendCreated', payload: { field: 'createdLinks', item: response } });
        }
        return response;
      } catch (error) {
        return { error: true, message: error.message || '创建文件链接失败' };
      }
    },

    *query({ payload }, { call, put }) {
      const response = yield call(query, payload);

      if (response) {
        yield put({
          type: 'updateState',
          payload: {
            materialsData: response,
          },
        });
      }
    },
  },
  reducers: {
    appendCreated(state, { payload: { field, item } }) {
      if (state[field].some((entry) => entry.id === item.id)) return state;
      return { ...state, [field]: [...state[field], item] };
    },
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    init(state, { payload }) {
      return {
        ...state,
        creating: true,
        folderId: null,
        createdLinks: [],
        createdMaterials: [],
        file2Upload: null,
        fileUploadProgress: 0,
        fileUploading: false,

        waitingFiles: [],
        successFiles: [],
        uploadedFiles: 0,
      };
    },
    end(state, { payload }) {
      return {
        ...state,
        creating: false,
        folderId: null,
        createdLinks: [],
        createdMaterials: [],
        file2Upload: null,
        fileUploadProgress: 0,
      };
    },
  },
};

export default MaterialModel;
